{
  "screen": {
    "heading": "Nuevo paciente",
    "explanation": "Para un paciente que no consta en la historia clínica. El número se toma de las pulseras preimpresas de reservnummer (número provisional) de la unidad; la historia clínica no asigna números por sí misma.",
    "searchFirst": "Busque primero. Un paciente que ya consta en la historia clínica no debe registrarse una segunda vez.",
    "noNationalNumber": "Aquí no se puede introducir un personnummer (número de identidad sueco). Busque primero al paciente: un paciente con personnummer suele constar ya en la historia clínica. Si no lo encuentra, regístrelo con un reservnummer de la pulsera.",
    "irreversible": "Un paciente registrado no se puede eliminar. Los errores se corrigen con una nueva versión.",
    "requiredHint": "Los campos sin indicación son obligatorios.",
    "optional": "opcional",
    "admitsTo": "El paciente ingresa en la unidad {ward}.",
    "noWard": "No se ha podido cargar ninguna unidad. El paciente no puede ingresar sin unidad.",
    "register": "Registrar al paciente",
    "registering": "Registrando …",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "discardQuestion": "¿Cerrar el formulario? Lo que ha escrito no se guardará.",
    "discardConfirm": "Cerrar sin registrar",
    "discardCancel": "Seguir rellenando",
    "registeredOk": "El paciente está registrado con {identifier} y consta en la historia clínica.",
    "registeredOnWard": "Ingreso en {ward}.",
    "openPatient": "Abrir la vista general del paciente",
    "registerAnother": "Registrar otro paciente"
  },
  "field": {
    "assigner": "Emitido por",
    "givenName": "Nombre",
    "familyName": "Apellidos",
    "sex": "Sexo",
    "isEstimatedIdentity": "La identidad es supuesta, no confirmada"
  },
  "fieldHint": {
    "identifier": "Lea el número de la pulsera, por ejemplo TST00000001. Tres letras y ocho cifras.",
    "ward": "La unidad en la que ingresa el paciente. Si la cambia aquí, también cambia la lista de la unidad.",
    "assigner": "La unidad propietaria de la serie de números de la que procede la pulsera.",
    "givenName": "Déjelo vacío si no se conoce el nombre.",
    "familyName": "Es obligatorio, o marque más abajo la identidad como supuesta.",
    "birthDate": "AAAA-MM-DD. Déjelo vacío si no se conoce la fecha de nacimiento.",
    "bed": "Habitación y cama tal como las nombra el personal. Déjelo vacío si no hay cama en este momento o si el paciente está en el pasillo: el paciente aparecerá entonces al final de la lista de la unidad, sin cama.",
    "isEstimatedIdentity": "Para un paciente que no puede ser identificado. La historia clínica mostrará entonces que el nombre y la fecha de nacimiento son una suposición.",
    "identifierDemo": "Entorno de prueba: aquí no hay pulseras que leer. Invente un número que empiece por TST8000 y termine con cuatro cifras propias, por ejemplo TST80001234. Si ya está en uso, el formulario lo indica: elija otras cuatro cifras."
  },
  "sex": {
    "notAnswered": "No indicado"
  },
  "refusal": {
    "identifierMissing": "Introduzca el reservnummer de la pulsera.",
    "identifierIsNationalNumber": "Parece un personnummer, y aquí no se puede introducir un personnummer. Busque al paciente en su lugar. Si no lo encuentra, regístrelo con un reservnummer de la pulsera. El número no se ha enviado.",
    "identifierMalformed": "El reservnummer no se acepta. Debe tener {letters} letras seguidas de {digits} cifras.",
    "identifierInUse": "{identifier} ya consta en la historia clínica. El paciente no se ha registrado de nuevo: abra el paciente existente.",
    "assignerMissing": "Indique qué unidad es propietaria de la serie de números.",
    "familyNameMissing": "Introduzca los apellidos, o marque la identidad como supuesta.",
    "fieldTooLong": "{field} es demasiado largo. Acórtelo a un máximo de {maximum} caracteres.",
    "sexUnknown": "El sexo no se acepta. Seleccione una de las opciones de la lista.",
    "birthDateMalformed": "La fecha de nacimiento no se acepta. Escríbala como AAAA-MM-DD, o deje el campo vacío.",
    "birthDateInFuture": "La fecha de nacimiento está en el futuro.",
    "wardMissing": "No hay ninguna unidad seleccionada. El paciente no se ha registrado.",
    "wardNotFound": "La unidad {ward} no consta en la historia clínica. El paciente no se ha registrado.",
    "roleMayNotDocument": "Su rol no permite documentar en la historia clínica. El paciente no se ha registrado.",
    "unknown": "El paciente no se ha registrado. Inténtelo de nuevo.",
    "unavailable": "Sin conexión con el servidor. El paciente no se ha registrado: deje el formulario abierto e inténtelo de nuevo."
  }
}
